import React, { Component } from 'react';

import { useParams, useNavigate, Link, } from 'react-router-dom';
import Pagination from "react-js-pagination";
import { apiUrl} from'../Config/Config';
import { lang } from '../Helpers/lang';
import Select from 'react-select';
import axios from 'axios';
import $ from 'jquery';
import moment from 'moment';
import {
  Row,
  Col,
  Modal,
  Table,
  OverlayTrigger,
  ButtonToolbar,
  Tooltip,
  Button
} from "react-bootstrap";
import Header from '../Layouts/Header';
import MenuSidebar from '../Layouts/MenuSidebar';
import { scrollToTopValidate,PageTitle } from "../Helpers/SettingHelper";

const withRouter = WrappedComponent => props => {
	const params = useParams();
	const  navigate = useNavigate();

	return (
	  <WrappedComponent
		{...props}
		params={params}
		navigate ={navigate}
	  />
	);
  };

class List extends Component {

  constructor(props)
  {
    super(props);
    this.state = {
    list:'',
	  activePage: 1,
	  totalRecord: '',
	  search_all:'',
	  selectedStatus:'',
	  selectid:'',
    categoryid:'',
    popupType:'',

    selectedFilOption:'',
    selectedFilvalue:'',
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFormSubmit = this.handleFormSubmit.bind(this);

    }


   componentDidMount() {
	  this.listloadedData()
   }

    listloadedData(postobject='') {
  var qs = require('qs');
   if(postobject!=''){
    var postobject = postobject
   }else{
    var postobject = {
      activePage: this.state.activePage,
      search_all: '',
      admin_id: localStorage.getItem('admin_id')
      };
   }

 axios.post(apiUrl+"CreditcardCategory/list",qs.stringify(postobject)).then(res => {

   if(res.data.status === 'success'){
       this.setState({list: res.data, totalRecord: res.data.records_count}, function() {
         this.list();
       });
   }else{
    this.setState({  list: '', totalRecord: 0}, function() {
      this.list();
    });
   }
 });
}

    handlePageChange(pageNumber) {
      this.setState({activePage: pageNumber});

      var qs = require('qs');

      var admin_id = localStorage.getItem("admin_id");

      var postobject = {
        activePage: pageNumber,
        search_all: this.state.search_all,
        admin_id: admin_id
      };
	  this.listloadedData(postobject);
    }

    handleInputChange(event) {
    const {name, value} = event.target;
    this.setState({
      [name]: value
    });
    var postObject = {
      activePage   : this.state.activePage,
      search_all : value,
      admin_id: localStorage.getItem('admin_id')
    };
    this.listloadedData(postObject)

  }
   handleFormSubmit = () => {

          this.setState({Loading:true});
          var qs = require('qs');

           var admin_id = localStorage.getItem("admin_id");
          var postObject = {
            activePage   : 1,
            search_all : this.state.search_all,
            filterVal : this.state.selectedFilvalue,
            admin_id: admin_id
          };
		  this.listloadedData(postObject);

    }

	deleteCategory(id){
        var qs = require('qs');
        var postObject = {
          admin_id : localStorage.getItem("admin_id"),
          id  :id
        };
      this.setState({categoryid : id, popupType: 'delete'})
      $('.confirm-action-delete-message').html('Are you sure! you want to delete the credit card category?');
      $('.confirm-action-delete').addClass('show');
	}

  list() {
    var list = this.state.list;
    if (list != "undefined" && list != null) {
      if (list.status == "success") {
        if (Object.keys(list).length > 0) {
          const listDetails = list.list.map(
            (list, Index) => {
              let sno = Index+1;
              if(list.status == 'A'){
                var status = 'Active';
              }else{
                  status = 'Inactive';
              }

              return (
                <tr key={list.id}>
                <td>{sno}</td>
                  <td>{list.cate_name}</td>
                  <td>{status}</td>
                   <td>{moment(list.created_on).format("MM/DD/YYYY")}</td>
                  <td className="actiongroup">
                    <Link to={{ pathname: '/creditcardcategory-edit/'+list.id}} className="" title="Edit">  <i className="ft-edit-3" aria-hidden="true"></i></Link>
                    <Link onClick={this.deletePopup.bind(this,list.id,'delete')} className="" title="Delete"><i className="ft-trash-2" aria-hidden="true"></i></Link>
                  </td>
                </tr>
              );
            }
          );
          return listDetails;
        }
      } else {
        return (
          <tr>
            <td colSpan="5" className="v-align-nr">
              No Result
            </td>
          </tr>
        );
      }
    }
  }

    deletePopup(id){
         
        //this.props.getDeleteCar(qs.stringify(postObject));
        this.setState({categoryid : id, popupType: 'delete'})
        $('.confirm-action-delete-message').html('Are you sure! you want to delete the category?');	
        $('.confirm-action-delete').addClass('show');	
    }

  confirmPopup =(confirmstatus,category_id = null , popupType=null)=>{
    if(confirmstatus == 'yes'){
      if(popupType == 'delete'){
        this.deleteConfirm(confirmstatus,category_id)
      }
    }else{
      $('.confirm-action-delete').removeClass('show');
    }
  }

  deleteConfirm =(confirmstatus,category_id)=>{
    if(confirmstatus == 'yes'){
			$('.confirm-action-delete').removeClass('show');
      var qs = require('qs');
      var postObject = {
        id: category_id,
        admin_id:localStorage.getItem("admin_id")
      };
      axios.post(apiUrl+"CreditcardCategory/delete",qs.stringify(postObject)).then(res => {
        if(res.data.status === 'success'){
          $('.success_message').html('<div class="status_sucess"><h3>'+ res.data.message+'</h3></div>');
          setTimeout(
          function() {
          $('.success_message').html('');
          this.setState({categoryid : '', popupType: ''});
          }
          .bind(this),
          3000
          );

          this.listloadedData()

        }
      });
    }else{
      $('.confirm-action-delete').removeClass('show');
    }
  }

  handleFilChange = (selOption) => {
    this.setState({selectedFilOption:selOption})
    this.setState({  selectedFilvalue : selOption.value},function(){
      this.handleFormSubmit()
    });
  };

  render() {
    return (
      <div className="wrapper">

    <Header />
    <MenuSidebar currentpage="creditcardcategory" currentTab="common" currentSubTab="creditcard-management" />

      <div className="content">
        <div className="content-wrapper">
          <div className="content-wrapper-before"></div>
          <div className="car-listing-wrap leaa-admin-head card">
            <div className="success_message"></div>
            <div className="listing-header">
              <div className="title">
                <h3>{this.state.totalRecord > 0?this.state.totalRecord:''} Credit Card Categor{this.state.totalRecord>1 ? 'ies' : 'y'}</h3>
              </div>
              <div className='listing-header-right-sec d-flex justify-content-end gap-2 w-100'>
                <div className="search-list">
                   <form className="edit" id="edit" onSubmit={ e => { this.handleFormSubmit(this); e.preventDefault(); }} >
                   <div className="input_search">
                        <div className="search-inner search_input">
                          <input type="text" name="search_all" onChange={this.handleInputChange} className="form-control" value={this.state.search_all} placeholder="Search" />
                          <button className="" type="submit">Submit</button>
                          <div className="erroremail"></div>
                        </div>
                  </div>
                 </form>
                </div>
                <div className="add_button">
                    <a className="primary-btn" href='/creditcardcategory-add'>Add</a>
                </div>
              </div>
            </div>

            <div className="car-listing-row">
              <Table striped bordered hover>
                <thead>
                  <tr>
                    <th width='80'>S.No</th>
                    <th width='350'>Category Name</th>
                    <th>Status</th>
                    <th>Added On</th>
                    <th width='100'>Action</th>
                  </tr>
                </thead>
                <tbody>{this.list()}</tbody>
              </Table>
              <div className="text-center">
                <Pagination
                activePage={this.state.activePage}
                itemsCountPerPage={10}
                totalItemsCount={this.state.totalRecord}
                pageRangeDisplayed={5}
                onChange={this.handlePageChange.bind(this)}
                />
              </div>
            </div>

          </div>
        </div>
      </div>

      <div className="confirm-action-delete">
        <p className="confirm-action-delete-message"></p>
        <a href="javascript://" onClick={this.confirmPopup.bind(this, "yes",this.state.categoryid, this.state.popupType)} className="btn">Yes</a>
        <a href="javascript://" onClick={this.confirmPopup.bind(this, "No")} className="btn">No</a>
        <span className="close-support" onClick={this.confirmPopup.bind(this, "No")}  >X</span>
      </div>
    </div>
    );
  }
}

export default withRouter(List);
